import axios from "@/utils/request";
// var baseUrl = 'http://118.190.240.47:8063/' //开发
// var baseUrl = "https://apidtest.ilvdo.com/"; //测试
var baseUrl = "https://apid.ilvdo.com/"; //正式
// export var url = "https://xtzghtest.ilvdo.com"; //测试
export var url = "https://xtzgh.ilvdo.com"; //正式

export const base = baseUrl;

export const UserLogIn = (data) => {
  return axios({
    url: baseUrl + "DeviceMobile/UserLogIn",
    method: "post",
    data,
  });
};
export const RunDeepSeekDeviceSimpleCompletionStream = (data) => {
  return axios({
    url: baseUrl + "DeviceMP/RunDeepSeekDeviceSimpleCompletionStream",
    method: "post",
    data,
  });
};
export const SendVerificationCode = (data) => {
  return axios({
    url: baseUrl + "DeviceMP/SendVerificationCode",
    method: "post",
    data,
  });
};
export const LXSendVerificationCode = (data) => {
  return axios({
    url: baseUrl + "DeviceMP/LXSendVerificationCode",
    method: "post",
    data,
  });
};
export const GetCarouselList = (data) => {
  return axios({
    url: baseUrl + "DeviceMP/GetCarouselList",
    method: "post",
    data,
  });
};
export const AddDeviceMPServiceClick = (data) => {
  return axios({
    url: baseUrl + "DeviceMP/AddDeviceMPServiceClick",
    method: "post",
    data,
  });
};
export const GetHomeCommunityLawyerList = (data) => {
  return axios({
    url: baseUrl + "DeviceMP/GetHomeCommunityLawyerList",
    method: "post",
    data,
  });
};
export const HomePageStatisticsData = (data) => {
  return axios({
    url: baseUrl + "EntityTerminal/HomePageStatisticsData",
    method: "post",
    data,
  });
};
export const GetPublicLawReleaseColumn = (data) => {
  return axios({
    url: baseUrl + "DeviceMP/GetPublicLawReleaseColumn",
    method: "post",
    data,
  });
};
export const GetPublicLawReleaseList = (data) => {
  return axios({
    url: baseUrl + "DeviceMP/GetPublicLawReleaseList",
    method: "post",
    data,
  });
};
export const GetRecentlyLawyerInfo = (data) => {
  return axios({
    url: baseUrl + "DeviceMP/GetRecentlyLawyerInfo",
    method: "post",
    data,
  });
};
export const GetMPCustomerInfo = (data) => {
  return axios({
    url: baseUrl + "DeviceMP/GetMPCustomerInfo",
    method: "post",
    data,
  });
};
export const GetUserDynamics = (data) => {
  return axios({
    url: baseUrl + "DeviceMP/GetUserDynamics",
    method: "post",
    data,
  });
};
export const GetLawboxInfo = (data) => {
  return axios({
    url: baseUrl + "DeviceMP/GetLawboxInfo",
    method: "post",
    data,
  });
};
export const GetBusinessManagementColumnArticle = (data) => {
  return axios({
    url: baseUrl + "DeviceMP/GetBusinessManagementColumnArticle",
    method: "post",
    data,
  });
};
export const GetBusinessManagementColumn = (data) => {
  return axios({
    url: baseUrl + "DeviceMP/GetBusinessManagementColumn",
    method: "post",
    data,
  });
};
export const GetConsultingHotline = (data) => {
  return axios({
    url: baseUrl + "DeviceMP/GetConsultingHotline",
    method: "post",
    data,
  });
};
export const IsExistSericePersonal = (data) => {
  return axios({
    url: baseUrl + "DevicePublicLegalService/IsExistSericePersonal",
    method: "post",
    data,
  });
};
export const MPPushPublicLegalServiceOrder = (data) => {
  return axios({
    url: baseUrl + "DevicePublicLegalService/MPPushPublicLegalServiceOrder",
    method: "post",
    data,
  });
};

export const GetQuestionByType = (data) => {
  return axios({
    url: baseUrl + "DeviceMP/GetQuestionByType",
    method: "post",
    data,
  });
};
export const GetAnswerByQuestion = (data) => {
  return axios({
    url: baseUrl + "DeviceMP/GetAnswerByQuestion",
    method: "post",
    data,
  });
};
export const FilterSensitiveWords = (data) => {
  return axios({
    url: baseUrl + "DeviceMP/FilterSensitiveWords",
    method: "post",
    data,
  });
};
export const RunDeviceSimpleCompletionStream = (data) => {
  return axios({
    url: baseUrl + "DeviceMP/RunDeviceSimpleCompletionStream",
    method: "post",
    data,
  });
};
export const GetLinkQuestion = (data) => {
  return axios({
    url: baseUrl + "DeviceMP/GetLinkQuestion",
    method: "post",
    data,
  });
};
export const GetProductInfo = (data) => {
  return axios({
    url: baseUrl + "DeviceMP/GetProductInfo",
    method: "post",
    data,
  });
};
export const GetMemberAndDeviceInfoBeforeQuickOrder = (data) => {
  return axios({
    url: baseUrl + "DeviceMobile/GetMemberAndDeviceInfoBeforeQuickOrder",
    method: "post",
    data,
  });
};
export const QuickTextOrder = (data) => {
  return axios({
    url: baseUrl + "DeviceMP/QuickTextOrder",
    method: "post",
    data,
  });
};
export const QuickTelOrder = (data) => {
  return axios({
    url: baseUrl + "DeviceMP/QuickTelOrder",
    method: "post",
    data,
  });
};
export const QuickVideoOrder = (data) => {
  return axios({
    url: baseUrl + "DeviceMP/QuickVideoOrder",
    method: "post",
    data,
  });
};
export const AppointmentLawyer = (data) => {
  return axios({
    url: baseUrl + "DeviceMP/AppointmentLawyer",
    method: "post",
    data,
  });
};
export const CheckOrderState = (data) => {
  return axios({
    url: baseUrl + "DeviceMP/CheckOrderState",
    method: "post",
    data,
  });
};
export const GetPublicLawReleaseDetail = (data) => {
  return axios({
    url: baseUrl + "DeviceMP/GetPublicLawReleaseDetail",
    method: "post",
    data,
  });
};
export const GetLawInCaseDetail = (data) => {
  return axios({
    url: baseUrl + "DeviceMP/GetLawInCaseDetail",
    method: "post",
    data,
  });
};
export const GetLawyerInfo = (data) => {
  return axios({
    url: baseUrl + "DeviceMP/GetLawyerInfo",
    method: "post",
    data,
  });
};
export const GetLegalServiceOrgListByLawboxId = (data) => {
  return axios({
    url: baseUrl + "DeviceMP/GetLegalServiceOrgListByLawboxId",
    method: "post",
    data,
  });
};
export const DirectionalTelOrder = (data) => {
  return axios({
    url: baseUrl + "DeviceMP/DirectionalTelOrder",
    method: "post",
    data,
  });
};
export const AddLegalAidOrderRecord = (data) => {
  return axios({
    url: baseUrl + "DeviceMP/AddLegalAidOrderRecord",
    method: "post",
    data,
  });
};
export const AddPeopleMediationOrderRecord = (data) => {
  return axios({
    url: baseUrl + "DeviceMP/AddPeopleMediationOrderRecord",
    method: "post",
    data,
  });
};
export const AddNotarizationOrderRecord = (data) => {
  return axios({
    url: baseUrl + "DeviceMP/AddNotarizationOrderRecord",
    method: "post",
    data,
  });
};
export const AddJudicialAppraisalOrderRecord = (data) => {
  return axios({
    url: baseUrl + "DeviceMP/AddJudicialAppraisalOrderRecord",
    method: "post",
    data,
  });
};
export const GetCommunityLawyerList = (data) => {
  return axios({
    url: baseUrl + "DeviceMP/GetCommunityLawyerList",
    method: "post",
    data,
  });
};
export const GetCommunityLawyerDetailInfo = (data) => {
  return axios({
    url: baseUrl + "DeviceMP/GetCommunityLawyerDetailInfo",
    method: "post",
    data,
  });
};
export const OrderInfo = (data) => {
  return axios({
    url: baseUrl + "DevicePublicLegalService/OrderInfo",
    method: "post",
    data,
  });
};
export const GetDeviceDocumentOrderList = (data) => {
  return axios({
    url: baseUrl + "DeviceMP/GetDeviceDocumentOrderList",
    method: "post",
    data,
  });
};
export const GetAgoraIOToken = (data) => {
  return axios({
    url: baseUrl + "DeviceMP/GetAgoraIOToken",
    method: "post",
    data,
  });
};
export const GetLegalAidOrderList = (data) => {
  return axios({
    url: baseUrl + "DeviceMP/GetLegalAidOrderList",
    method: "post",
    data,
  });
};
export const CancelOrder = (data) => {
  return axios({
    url: baseUrl + "DevicePublicLegalService/CancelOrder",
    method: "post",
    data,
  });
};
export const GetPeopleMediationOrderList = (data) => {
  return axios({
    url: baseUrl + "DeviceMP/GetPeopleMediationOrderList",
    method: "post",
    data,
  });
};
export const FinishOrder = (data) => {
  return axios({
    url: baseUrl + "DevicePublicLegalService/FinishOrder",
    method: "post",
    data,
  });
};
export const GetNotarizationOrderList = (data) => {
  return axios({
    url: baseUrl + "DeviceMP/GetNotarizationOrderList",
    method: "post",
    data,
  });
};
export const GetAllLawyers = (data) => {
  return axios({
    url: baseUrl + "DeviceMP/GetAllLawyers",
    method: "post",
    data,
  });
};
export const GetJudicialAppraisalOrderList = (data) => {
  return axios({
    url: baseUrl + "DeviceMP/GetJudicialAppraisalOrderList",
    method: "post",
    data,
  });
};
export const CanOperation = (data) => {
  return axios({
    url: baseUrl + "DeviceMP/CanOperation",
    method: "post",
    data,
  });
};
export const GetDiffrentTypeConsultOrderList = (data) => {
  return axios({
    url: baseUrl + "DeviceMP/GetDiffrentTypeConsultOrderList",
    method: "post",
    data,
  });
};
export const GetSaveNumber = (data) => {
  return axios({
    url: baseUrl + "DeviceMP/GetSaveNumber",
    method: "post",
    data,
  });
};
export const GetLegalAidOrderDetail = (data) => {
  return axios({
    url: baseUrl + "DeviceMP/GetLegalAidOrderDetail",
    method: "post",
    data,
  });
};
export const DirectionalTextOrder = (data) => {
  return axios({
    url: baseUrl + "DeviceMP/DirectionalTextOrder",
    method: "post",
    data,
  });
};
export const GetNotarizationOrderDetail = (data) => {
  return axios({
    url: baseUrl + "DeviceMP/GetNotarizationOrderDetail",
    method: "post",
    data,
  });
};
export const DirectionalVideoOrderModel = (data) => {
  return axios({
    url: baseUrl + "DeviceMP/DirectionalVideoOrderModel",
    method: "post",
    data,
  });
};
export const GetPeopleMediationOrderDetail = (data) => {
  return axios({
    url: baseUrl + "DeviceMP/GetPeopleMediationOrderDetail",
    method: "post",
    data,
  });
};
export const GetAllUnCommentOrderList = (data) => {
  return axios({
    url: baseUrl + "DeviceMP/GetAllUnCommentOrderList",
    method: "post",
    data,
  });
};
export const GetJudicialAppraisalOrderDetail = (data) => {
  return axios({
    url: baseUrl + "DeviceMP/GetJudicialAppraisalOrderDetail",
    method: "post",
    data,
  });
};
export const GetLawyerServiceInfo = (data) => {
  return axios({
    url: baseUrl + "DeviceMP/GetLawyerServiceInfo",
    method: "post",
    data,
  });
};
export const GetLawsRegulationsList = (data) => {
  return axios({
    url: baseUrl + "DeviceMP/GetLawsRegulationsList",
    method: "post",
    data,
  });
};
export const IsExistOrder = (data) => {
  return axios({
    url: baseUrl + "DeviceMP/IsExistOrder",
    method: "post",
    data,
  });
};
export const GetLawsRegulationsContent = (data) => {
  return axios({
    url: baseUrl + "DeviceMP/GetLawsRegulationsContent",
    method: "post",
    data,
  });
};
export const SubmitFeedbackInfo = (data) => {
  return axios({
    url: baseUrl + "DeviceMP/SubmitFeedbackInfo",
    method: "post",
    data,
  });
};
export const GetClassicCaseList = (data) => {
  return axios({
    url: baseUrl + "DeviceMP/GetClassicCaseList",
    method: "post",
    data,
  });
};
export const CommentInfo = (data) => {
  return axios({
    url: baseUrl + "DeviceMP/CommentInfo",
    method: "post",
    data,
  });
};
export const GetClassicCaseDetail = (data) => {
  return axios({
    url: baseUrl + "DeviceMP/GetClassicCaseDetail",
    method: "post",
    data,
  });
};
export const AddComment = (data) => {
  return axios({
    url: baseUrl + "DeviceMP/AddComment",
    method: "post",
    data,
  });
};
export const GetLawInCaseList = (data) => {
  return axios({
    url: baseUrl + "DeviceMP/GetLawInCaseList",
    method: "post",
    data,
  });
};
export const GetLegalServiceMapList = (data) => {
  return axios({
    url: baseUrl + "DeviceMP/GetLegalServiceMapList",
    method: "post",
    data,
  });
};
export const GetLawOnlineList = (data) => {
  return axios({
    url: baseUrl + "DeviceMP/GetLawOnlineList",
    method: "post",
    data,
  });
};
export const GetLawOnlineDetail = (data) => {
  return axios({
    url: baseUrl + "DeviceMP/GetLawOnlineDetail",
    method: "post",
    data,
  });
};
export const AddBindRelation = (data) => {
  return axios({
    url: baseUrl + "DeviceMP/AddBindRelation",
    method: "post",
    data,
  });
};
export const GetMemberInfo = (data) => {
  return axios({
    url: baseUrl + "DeviceMP/GetMemberInfo",
    method: "post",
    data,
  });
};
export const UpdateMemberInfo = (data) => {
  return axios({
    url: baseUrl + "DeviceMP/UpdateMemberInfo",
    method: "post",
    data,
  });
};
export const UploadFile = (data) => {
  return axios({
    url: baseUrl + "Common/UploadFile",
    method: "post",
    data,
  });
};
export const LXUploadFile = (data) => {
  return axios({
    url: baseUrl + "Common/LXUploadFile",
    method: "post",
    data,
  });
};
export const GetLegalDocTempletList = (data) => {
  return axios({
    url: baseUrl + "DeviceMP/GetLegalDocTempletList",
    method: "post",
    data,
  });
};
export const GetLocalLawyerList = (data) => {
  return axios({
    url: baseUrl + "DeviceMP/GetLocalLawyerList",
    method: "post",
    data,
  });
};
export const GetLawyerDetailInfo = (data) => {
  return axios({
    url: baseUrl + "DeviceMP/GetLawyerDetailInfo",
    method: "post",
    data,
  });
};
export const GetLawyerTopComment = (data) => {
  return axios({
    url: baseUrl + "DeviceMP/GetLawyerTopComment",
    method: "post",
    data,
  });
};
export const GetLawyerCommentList = (data) => {
  return axios({
    url: baseUrl + "DeviceMP/GetLawyerCommentList",
    method: "post",
    data,
  });
};
export const CommentOrder = (data) => {
  return axios({
    url: baseUrl + "DevicePublicLegalService/CommentOrder",
    method: "post",
    data,
  });
};
export const AppointmentTelOrder = (data) => {
  return axios({
    url: baseUrl + "DeviceMP/AppointmentTelOrder",
    method: "post",
    data,
  });
};
